import "../../css/integration.css";
import top from "./script-top.png";
import bottom from "./script-bottom.png";
import { CodeBlock, dracula } from "react-code-blocks";
import { Button } from "@mui/material";
import { useLocation } from "react-router-dom";

export function Integration() {
  const location = useLocation();
  const { adminAddr, appMeta } = location.state;
  const code = `<script> CONTRACT_ADDRESS = "${appMeta.addr}"\nLOGIC_ADDRESS = "${appMeta.logicAddress}"\nIS_TESTNET = true \n</script> \
    <script src="https://catchon-ethsf-kxj7blfz1-catchon-labs.vercel.app/static/js/main.js">\n</script><link href="https://catchon-ethsf-kxj7blfz1-catchon-labs.vercel.app/static/css/main.css" rel="stylesheet">`;
  console.log("dracula: ", dracula);
  return (
    <>
      <h1>This is Integration!</h1>

      <div>
        <div className="step">
          <div className="leftPart">
            <span>Step 1.</span>
            <span>Choose a eCommerce wesite template at Webflow.</span>
          </div>
          <div className="rightPart">
            <img src={top} alt="Italian Trulli" />
          </div>
        </div>
        <div className="step">
          <div className="leftPart">
            <span>Step 2.</span>
            <span>
              Copy the script below, generated by CatchOn sepcially for your
              store.
            </span>
          </div>
          <div className="rightPart">
            <CodeBlock
              text={code}
              language="html"
              showLineNumbers={true}
              theme={dracula}
              codeBlock
            />
            <Button
              id={"copy-button"}
              onClick={async () => {
                await navigator.clipboard.writeText(code);
                alert("Copied!");
              }}
            >
              Copy
            </Button>
          </div>
        </div>
        <div className="step">
          <div className="leftPart">
            <span>Step 3.</span>
            <span>
              Paste the script in the hightlighted area. Then, launch your
              eCommerce and start erarning!
            </span>
          </div>
          <div className="rightPart">
            <img src={bottom} alt="Italian Trulli" />
          </div>
        </div>
      </div>
    </>
  );
}
